import {
  Boarbichler_Hofkistl2,
  Boarbichler_Kasebox,
  JoggeleWeiss,
  Kaminwurzen,
  Knottnkas,
  Kraeutermandl,
  Rebell,
  SchmugglerLuis,
  Weibele,
  Xaver,
  Joghurt,
  TallnerHart,
  Wochentaschl,
  GeschenkBrettl
} from "../static";

const data = [
  {
    title: "S' Weibele",
    image: Weibele,
    description:
      "Milder frischer Schnittkäse, ähnlich wie Mozzarella. 10 Tage im Vakuum gereift.",
    subDescription: "20€/kg - Vakuumiert verpackt, 10 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "Weibele0g",
        unit: "0g",
        price: 0
      },
      {
        id: "Weibele200g",
        unit: "200g",
        price: 4.0
      },
      {
        id: "Weibele400g",
        unit: "400g",
        price: 8.0
      },
      {
        id: "Weibele600g",
        unit: "600g",
        price: 12.0
      },
      {
        id: "Weibele800g",
        unit: "800g",
        price: 16.0
      },
      {
        id: "Weibele1000g",
        unit: "1000g",
        price: 20.0
      }
    ]
  },
  {
    title: "Joggele Weiss",
    image: JoggeleWeiss,
    description: "Milder Weichkäse mit Weißschimmel mit 14 Tagen Reifung.",
    subDescription: "29€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.8
      },
      {
        id: "400g",
        unit: "400g",
        price: 11.6
      },
      {
        id: "600g",
        unit: "600g",
        price: 17.4
      },
      {
        id: "800g",
        unit: "800g",
        price: 23.2
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 29.0
      }
    ]
  },
  {
    title: "Kräutermandl",
    image: Kraeutermandl,
    description:
      "Leicht würziger Schnittkäse mit Brotgewürz. 14 Tage Reifung.",
    subDescription: "25€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.0
      },
      {
        id: "400g",
        unit: "400g",
        price: 10.0
      },
      {
        id: "600g",
        unit: "600g",
        price: 15.0
      },
      {
        id: "800g",
        unit: "800g",
        price: 20.0
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 25.0
      }
    ]
  },
  {
    title: "Rebell",
    image: Rebell,
    description: "Leicht würziger Schnittkäse, 4-6 Wochen Reifung.",
    subDescription: "25€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.0
      },
      {
        id: "400g",
        unit: "400g",
        price: 10.0
      },
      {
        id: "600g",
        unit: "600g",
        price: 15.0
      },
      {
        id: "800g",
        unit: "800g",
        price: 20.0
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 25.0
      }
    ]
  },
  {
    title: "Schmuggler Luis",
    image: SchmugglerLuis,
    description:
      "Würzig-pfeffriger Schnittkäse mit Pfefferkorn, 4-6 Wochen Reifung.",
    subDescription: "25€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.0
      },
      {
        id: "400g",
        unit: "400g",
        price: 10.0
      },
      {
        id: "600g",
        unit: "600g",
        price: 15.0
      },
      {
        id: "800g",
        unit: "800g",
        price: 20.0
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 25.0
      }
    ]
  },
  {
    title: "Xaver",
    image: Xaver,
    description:
      "Leicht scharfer Schnittkäse mit Peperoncino, 4-6 Wochen Reifung.",
    subDescription: "25€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.0
      },
      {
        id: "400g",
        unit: "400g",
        price: 10.0
      },
      {
        id: "600g",
        unit: "600g",
        price: 15.0
      },
      {
        id: "800g",
        unit: "800g",
        price: 20.0
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 25.0
      }
    ]
  },
  {
    title: "Knottn Kaas",
    image: Knottnkas,
    description: "Würzig-eleganter halbharter Schnittkäse, 3-6 Monate Reifung.",
    subDescription: "29€/kg - Vakuumiert verpackt, 14 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 5.8
      },
      {
        id: "400g",
        unit: "400g",
        price: 11.6
      },
      {
        id: "600g",
        unit: "600g",
        price: 17.4
      },
      {
        id: "800g",
        unit: "800g",
        price: 23.2
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 29.0
      }
    ]
  },
  {
    title: "Tallner Hart",
    image: TallnerHart,
    description: "Hartkäse würzig, 18 Monate Reifung",
    subDescription: "30€/kg - Vakuumiert verpackt, 21 Tage haltbar.",
    available: false,
    dropDown: [
      {
        id: "0g",
        unit: "0g",
        price: 0
      },
      {
        id: "200g",
        unit: "200g",
        price: 6.0
      },
      {
        id: "400g",
        unit: "400g",
        price: 12.0
      },
      {
        id: "600g",
        unit: "600g",
        price: 18.0
      },
      {
        id: "800g",
        unit: "800g",
        price: 24.0
      },
      {
        id: "1000g",
        unit: "1000g",
        price: 30.0
      }
    ]
  },
  {
    title: "Kaminwurzen",
    image: Kaminwurzen,
    description:
      "Kaminwurzen Rind Fein würzig, rauchiges Aroma, luftgetrocknet.",
    subDescription: "2.20€/Stück - Vakuumiert verpackt, 30 Tage haltbar.",
    available: true,
    dropDown: [
      {
        id: "Kaminwurzen0",
        unit: "0",
        price: 0
      },
      {
        id: "Kaminwurzen1",
        unit: "1",
        price: 2.2
      },
      {
        id: "Kaminwurzen2",
        unit: "2",
        price: 4.4
      },
      {
        id: "Kaminwurzen4",
        unit: "4",
        price: 8.8
      },
      {
        id: "Kaminwurzen6",
        unit: "6",
        price: 13.2
      },
      {
        id: "Kaminwurzen8",
        unit: "8",
        price: 17.6
      },
      {
        id: "Kaminwurzen10",
        unit: "10",
        price: 22.0
      }
    ]
  },
  {
    title: "Joghurt",
    image: Joghurt,
    description:
      "Joghurt natur, mild",
    subDescription: "3.6€/Stück - Glas, 580ml Inhalt, 14 Tage haltbar",
    available: true,
    dropDown: [
      {
        id: "Joghurt0",
        unit: "0",
        price: 0
      },
      {
        id: "Joghurt1",
        unit: "1",
        price: 3.6
      },
      {
        id: "Joghurt2",
        unit: "2",
        price: 7.2
      },
      {
        id: "Joghurt4",
        unit: "4",
        price: 14.4
      },
      {
        id: "Joghurt6",
        unit: "6",
        price: 21.6
      },
      {
        id: "Joghurt8",
        unit: "8",
        price: 28.8
      },
      {
        id: "Joghurt10",
        unit: "10",
        price: 36.0
      }
    ]
  },
  {
    title: "Geschenkbox",
    image: Boarbichler_Kasebox,
    description:
      "18x18 cm, beinhaltet 3 verschiedene Käsesorten und 2 Kaminwurzen.",
    subDescription: "25€/Stück",
    available: true,
    dropDown: [
      {
        unit: "0",
        price: 0
      },
      {
        unit: "1",
        price: 25
      },
      {
        unit: "2",
        price: 50
      },
      {
        unit: "3",
        price: 75
      },
      {
        unit: "4",
        price: 100
      },
      {
        unit: "5",
        price: 125
      }
    ]
  },
  {
    title: "Boarbichler Hofkistl",
    image: Boarbichler_Hofkistl2,
    description:
      "Handerlesene Käse und Wurst Premiumselektion aus dem gesamten Boarbichl Hofsortiment.",
    subDescription: "45€/Stück",
    available: true,
    dropDown: [
       {
        unit: "0",
        price: 0
      },
      {
        unit: "1",
        price: 45
      },
      {
        unit: "2",
        price: 90
      },
      {
        unit: "3",
        price: 135
      },
      {
        unit: "4",
        price: 180
      },
      {
        unit: "5",
        price: 225
      }
    ]
  },
  {
    title: "s'Wochentaschl",
    image: Wochentaschl,
    description:
      "1 Joghurt, 3 verschiedene Käsesorten (total ca. 700g), 6 Eier, 2 Kaminwurzen",
    subDescription: "35€/Stück",
    available: true,
    dropDown: [
      {
        unit: "0",
        price: 0
      },
      {
        unit: "1",
        price: 35
      },
      {
        unit: "2",
        price: 70
      },
      {
        unit: "3",
        price: 105
      },
      {
        unit: "4",
        price: 140
      },
      {
        unit: "5",
        price: 175
      }
    ]
  },
  {
    title: "Geschenk-Brettl",
    image: GeschenkBrettl,
    description:
      "1 Laib Käse (ca.1kg), 4 Kaminwurzen Rind, hand-gemachtes Schneidebrett (35x25cm)",
    subDescription: "45€/Stück",
    available: true,
    dropDown: [
      {
        unit: "0",
        price: 0
      },
      {
        unit: "1",
        price: 45
      },
      {
        unit: "2",
        price: 90
      },
      {
        unit: "3",
        price: 135
      },
      {
        unit: "4",
        price: 180
      },
      {
        unit: "5",
        price: 225
      }
    ]
  }
];

export { data as default};
